import siteHeader from "./site-header/site-header.js";

(() => {
  if (document.querySelectorAll(".header").length) {
    let header = new siteHeader();
    header.init();
  }
})();
